






























































































































































































import ProductColor from "../components/ProductColor.vue";
import Vue from "vue";
import Component from "vue-class-component";
import ProductSize from "./ProductSize.vue";
import { Watch, Prop } from "vue-property-decorator";
import AddToCartArgs from "@/chipply/AddToCartArgs";
import ProductOption from "@/chipply/ProductOption";
import { FieldValueCollectionEditViewModel, WebHelper } from "chipply-common";
import FieldValueCollectionEditor from "./common-vue/FieldValueCollectionEditor.vue";
import ProductViewModel from "@/chipply/view-model/ProductViewModel";
import ParentProductViewModel from "@/chipply/view-model/ParentProductViewModel";
import IProcessOptionModel from "@/chipply/IProcessOptionModel";
import RecaptchaClient from "@/chipply/verify/RecaptchaClient";
import CartViewModel from "@/chipply/view-model/CartViewModel";
import ProductDialog from "./ProductDialog.vue";
import { mask } from "vue-the-mask";
import Validation from "@/chipply/Validation";
import ProductOptionDisplay from "@/components/design-elements/ProductOptionDisplay.vue";
import ChooseYourDesign from "@/components/design-elements/ChooseYourDesign.vue";
import QuantityComponent from "@/components/design-elements/QuantityComponent.vue";
import RadioButtonModel from "@/chipply/RadioButtonModel";
import BasicProductInfo from "@/components/BasicProductInfo.vue";
import GroupProductSelector from "@/components/GroupProductSelector.vue";
import { StoreProductGroupMemberDetails } from "@/chipply/StoreProductGroupMemberDetailModel";
import GroupProductsHeader from "@/components/page/GroupProductsHeader.vue";
import CSizingChart from "@/components/CSizingChart.vue";
import CartQuantityWarning from "@/components/CartQuantityWarning.vue";
import ProductQuantityViewModel from "@/chipply/view-model/ProductQuantityViewModel";
import vuetify from "@/plugins/vuetify";
import { IBulkSize } from "@/chipply/IBulkSize";

@Component({
    components: {
        CartQuantityWarning,
        CSizingChart,
        GroupProductsHeader,
        GroupProductSelector,
        BasicProductInfo,
        QuantityComponent,
        ChooseYourDesign,
        ProductOptionDisplay,
        ProductColor,
        ProductSize,
        ProductDialog,
        FieldValueCollectionEditor,
    },
    props: {
        // productColors: Array,
        colorSize: Object,
        value: Object,
        cartVm: Object,
        packageView: Boolean,
        hidePrice: Boolean,
        maxReached: Boolean,
        pvm: Object,
        fieldVm: Object,
    },
    directives: {
        mask,
    },
})
export default class ProductInfoSelector extends Vue {
    @Prop({
        default: false,
        type: Boolean,
    })
    public packageView!: boolean;

    @Prop({
        default: false,
        type: Boolean,
    })
    public allowMultiple!: boolean;

    @Prop({ type: Array })
    public commonBulkSizes!: IBulkSize[];

    public name = `ProductInfoSelector`;
    public Validation = Validation;
    private value!: ProductViewModel;
    private sizeError = false;
    private cartVm!: CartViewModel;
    public qtyVm = new ProductQuantityViewModel();
    private maxReached!: boolean;
    private noDesignSelected = false;
    public pvm!: ParentProductViewModel;
    private disableButton = false;
    private qtyValid = false;
    private colorChosen = false;
    public fieldIsValid = false;

    private onFieldValidationChanged(valid: boolean) {
        this.fieldIsValid = valid;
    }

    public get productDescriptionStyleObject() {
        return {
            color: "#6e6e70",
            fontStyle: "normal",
            fontWeight: "400",
            lineHeight: "120%",
            fontSize: this.$vuetify.breakpoint.smAndUp && !this.packageView ? "18px" : "14px",
            overflow: this.$vuetify.breakpoint.smAndUp ? "visible" : "hidden",
        };
    }

    @Prop({
        default: null,
        type: FieldValueCollectionEditViewModel,
    })
    public fieldVm!: FieldValueCollectionEditViewModel;

    // @ts-ignore
    public $refs!: {
        optionForm: any;
        qtyForm: any;
        qtyComponent: QuantityComponent;
        snack: ProductDialog;
        fieldEditor: FieldValueCollectionEditor;
        productSizeSelector: ProductSize;
    };

    protected async recaptchaHandler() {
        const recaptchaClient = new RecaptchaClient();
        const token = await recaptchaClient.execute({
            action: "submit",
        });
        return token;
    }

    public async created() {
        await this.value.setInitialColorSize();
        if (this.value.product) {
            if (!this.value.productQuantity || this.value.productQuantity == 0) {
                this.value.productQuantity = this.value.product.minQuantity;
            }

            if (this.value.product.designCount > 1 && !this.value.checkForEnabledDesign()) {
                //this.value.colorSize.designsObject.designs[0].enabled = true;
            }

            this.value.options.forEach((option) => {
                if (option.processType == 5) {
                    option.originalValue = option.userValue;
                }
            });
        }
        this.qtyVm.allowMultiple = this.allowMultiple;
    }

    @Watch("qtyVm.outOfBounds")
    protected async onOutOfBoundsChanged() {
        this.disableButton = this.qtyVm.outOfBounds;
    }

    protected get computedCartMaxReached() {
        if (
            this.maxReached ||
            (this.qtyVm.outOfBounds && this.qtyVm.calculateCurrentMax(this.value, this.pvm, this.cartVm) < 0)
        ) {
            this.disableButton = true;
            return true;
        }
        return false;
    }

    private specifiedQuantity() {
        if (this.value.product) {
            if (this.value.product.minQuantity == this.value.product.maxQuantity) {
                return true;
            } else {
                return false;
            }
        }
    }

    private calculateOptionCols(option: IProcessOptionModel) {
        if (this.packageView || !this.$vuetify.breakpoint.smAndUp || option.extraFee != 0) {
            return "12";
        } else {
            return "6";
        }
    }

    private calculateCols(where: string) {
        switch (where) {
            case "options":
                if (this.packageView || !this.$vuetify.breakpoint.smAndUp) {
                    return "12";
                } else {
                    return "6";
                }
            case "sizing":
                return "12";

            case "quantity":
                if (this.packageView || !this.$vuetify.breakpoint.smAndUp) {
                    return "12";
                } else {
                    return "4";
                }
            case "button":
                if (this.packageView) {
                    return "12";
                } else {
                    return "8";
                }
            default:
                break;
        }
    }

    protected screenCheck() {
        if (this.$vuetify.breakpoint.smAndUp) {
            return true;
        } else {
            return false;
        }
    }

    public async setSize(sizeId: number) {
        this.sizeError = false;
        await this.value.disableColors(sizeId);
        this.value.selectedSize = sizeId;
        const size = this.value.productSizeCollection.find((c) => c.value === sizeId);
        this.value.selectedSizeDisplay = size.display;

        const allSelectedSizesAreFalse = this.value.productSizeCollection.every((item) => !item.selected);

        if (allSelectedSizesAreFalse) {
            this.value.productColorCollection.forEach((myColor) => {
                myColor.enabled = true;
            });
        }

        //should run after each size selection because the dictionary will be different
        this.qtyVm.validateQuantity(this.value, this.pvm, this.cartVm, this.value.productQuantity);
    }

    public isSticky() {
        if (this.value.selectedSize == 0) {
            return false;
        }
        if (
            this.$refs.optionForm &&
            this.$refs.qtyComponent &&
            (!this.$refs.optionForm.validate() || !this.$refs.qtyComponent.validateForm())
        ) {
            //don't add to cart
            this.$refs.optionForm.resetValidation();
            this.$refs.qtyComponent.resetValidation();
            return false;
        } else {
            return true;
        }
    }

    public async setInitialColor(preset?: object) {
        this.value.setInitialColorSize();
    }

    private async disableSizes(id: number) {
        if (id != undefined && this.value.colorSize != undefined) {
            var targetDictionary = this.value.colorSize.colorSizeDictionary![id];
            var keys = Object.keys(targetDictionary);
            this.value.productSizeCollection = [];
            this.value.colorSize.sizes?.forEach((element) => {
                var model: { display: string; value: number; selected: boolean; enabled: boolean } = {
                    display: element.display,
                    value: element.value,
                    selected: false,
                    enabled: keys.includes("" + element.value),
                };
                this.value.productSizeCollection.push(new RadioButtonModel(model));
            });

            if (this.value.productSizeCollection.length == 1) {
                this.value.productSizeCollection[0].selected = true;
                this.value.selectedSize = this.value.productSizeCollection[0].value;
            }
        }
    }

    public async updatePackageItem() {
        if (this.value.selectedSize == 0) {
            this.sizeError = true;
            this.$refs.productSizeSelector.$el.scrollIntoView();
            return;
        } else {
            this.sizeError = false;
        }

        if (!this.value.checkForEnabledDesign() && this.value.product!.designCount > 1) {
            this.noDesignSelected = true;
            return;
        }
        if (this.qtyVm.calculateCurrentMax(this.value, this.pvm, this.cartVm) == 0) {
            this.qtyVm.outOfBounds = true;
            return;
        }

        if (!this.$refs.optionForm.validate() || !this.$refs.qtyComponent.validateForm() || this.qtyVm.outOfBounds) {
            //don't update
        } else {
            this.value.pkgItemFinalized = true;
            this.$emit("finalize");
        }
    }

    public async addToCart() {
        if (this.disableButton) {
            return;
        }
        this.disableButton = true;
        try {
            var args = new AddToCartArgs();
            args.productId = this.value.product!.eventProductID;
            args.sizeId = this.value.selectedSize!;
            args.categoryId = this.value.categoryId;
            args.colorId = this.value.selectedColor.eventProductColorId;

            //let qty = parseInt(this.displayQty!.slice(4));
            let qty = this.value.productQuantity;
            args.quantity = qty;
            args.eventId = this.value.product!.eventID;

            //Product options stuff goes here
            this.value.options.forEach((option) => {
                if (option.userValue != undefined) {
                    const po = new ProductOption();
                    if (option.processType == 4 || option.processType == 5) {
                        option.options.forEach((choice) => {
                            if (choice.display == option.userValue) {
                                po.processOptionId = choice.optionItemId;
                            }
                        });
                    }
                    po.text = option.userValue;
                    po.processItemId = option.optionId;
                    args.productOptions.push(po);
                }
            });

            if (this.fieldVm) {
                args.fieldValues = this.fieldVm.toModel();
            }

            if (!this.value.checkForEnabledDesign() && this.value.product!.designCount > 1) {
                this.noDesignSelected = true;
                this.disableButton = false;
                return;
            }

            if (this.value.selectedSize == 0) {
                this.sizeError = true;
                this.$refs.productSizeSelector.$el.scrollIntoView();
                this.disableButton = false;
                return;
            } else {
                this.sizeError = false;
            }

            if (this.qtyVm.outOfBounds) {
                this.disableButton = false;
                return;
            }

            if (!this.$refs.optionForm.validate() || !this.$refs.qtyComponent.validateForm()) {
                //don't add to cart
            } else {
                this.value.loading = true;
                await WebHelper.postJsonData("/api/EventProductEcom/AddToCart", args);
                await this.$refs.snack.showSnackbar();
                this.value.loading = false;
            }
        } finally {
            this.disableButton = false;
        }
    }

    public designSelected(design: any) {
        this.noDesignSelected = false;
        const changeDesignObject = {
            colorSelected: this.colorChosen,
            selectedDesign: design.value,
            selectedDesignDisplay: design.display,
            fieldVm: this.fieldVm,
        };

        this.$emit("designChanged", changeDesignObject);
    }

    public groupProductSelected = (model: StoreProductGroupMemberDetails) => {
        const args = {
            colorSelected: true,
            selectedDesign: model.productId,
        };
        this.$emit("designChanged", args);
    };

    private async disableColors(id: number) {
        var colors = Object.keys(this.value.colorSize.colorSizeDictionary!);
        colors.forEach((color) => {
            var sizes = Object.keys(this.value.colorSize.colorSizeDictionary![color as unknown as number]);
            var combo = this.value.colorSize.colorSizeDictionary![color as unknown as number][id];

            if (combo == undefined) {
                this.value.productColorCollection.forEach((myColor) => {
                    if (myColor.eventProductColorId == color) {
                        myColor.enabled = false;
                    }
                });
            } else {
                this.value.productColorCollection.forEach((myColor) => {
                    if (myColor.eventProductColorId == color) {
                        myColor.enabled = true;
                    }
                });
            }
        });
    }

    private async rebuildColorsAndSizes() {
        this.value.productColorCollection = [];
        this.value.colorSize.colors?.forEach((element) => {
            var targetDictionary = this.value.colorSize.colorSizeDictionary![element.eventProductColorId];

            var model: { colorName: string; hexValue: string; eventProductColorId: number; enabled: boolean } = {
                colorName: element.colorName,
                hexValue: element.hexCode1,
                eventProductColorId: element.eventProductColorId,
                enabled: Object.keys(targetDictionary).length > 0,
            };

            this.value.productColorCollection.push(model);
        });

        //need to setup the size array and disable any that aren't available in the initial color
        this.value.productSizeCollection = [];
        var keys = Object.keys(this.value.colorSize.colorSizeDictionary![this.value.selectedColor.eventProductColorId]);
        this.value.colorSize.sizes?.forEach((element) => {
            var model: { display: string; value: number; selected: boolean; enabled: boolean } = {
                display: element.display,
                value: element.value,
                selected: false,
                enabled: keys.includes("" + element.value),
            };
            this.value.productSizeCollection.push(new RadioButtonModel(model));
        });

        if (this.value.productSizeCollection.length == 1) {
            this.value.productSizeCollection[0].selected = true;
            this.value.selectedSize = this.value.productSizeCollection[0].value;
        }
    }

    @Watch("value.selectedColor")
    protected async onColorChanged() {
        if (this.value.selectedColor != undefined && this.value.selectedColor != "") {
            await this.value.rebuildColorsAndSizes(this.value.selectedColor.eventProductColorId);
            await this.disableSizes(this.value.selectedColor.eventProductColorId);

            if (this.value.selectedSize != 0) {
                await this.disableColors(this.value.selectedSize);
            }

            this.$emit("color", this.value.selectedColor.eventProductColorId);
        }

        this.qtyVm.validateQuantity(this.value, this.pvm, this.cartVm, this.value.productQuantity);
    }

    @Watch("value.selectedSize")
    protected async onSizeChanged() {
        this.qtyVm.validateQuantity(this.value, this.pvm, this.cartVm, this.value.productQuantity);
    }
}
